import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Button,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import TitleHeaders from "../../../Components/CluppForms/TitleHeaders";

const CluppValuation = () => {
  const data = [
    {
      name: "Clupp Mutualidad, S.C. de R.L. de C.V.",
      rating: 9.6,
      isClupp: true,
    },
    { name: "ABA Seguros, S.A. de C.V.", rating: 7.9 },
    { name: "AXA Seguros, S.A. de C.V.", rating: 7.6 },
    { name: "Grupo Nacional Provincial, S.A.B.", rating: 7.5 },
    { name: "Qualitas Compañía de Seguros, S.A.B. de C.V.", rating: 7.4 },
    { name: "Seguros Banamex, S.A. de C.V.", rating: 7.3 },
    { name: "Seguros Inbursa, S.A.", rating: 7.1 },
    { name: "HSBC Seguros, S.A. de C.V.", rating: 7.1 },
    { name: "Seguros Monterrey New York Life, S.A. de C.V.", rating: 7.0 },
    { name: "Metlife México, S.A.", rating: 7.0 },
    { name: "Mapfre Tepeyac, S.A.", rating: 6.9 },
    { name: "Seguros BBVA Bancomer, S.A. de C.V.", rating: 6.7 },
    { name: "Zurich Santander Seguros México, S.A.", rating: 6.4 },
    { name: "Seguros Argos, S.A. de C.V.", rating: 6.2 },
  ];

  const averageRating = 7.1;

  const [visibleRows, setVisibleRows] = useState(5);
  const [showAll, setShowAll] = useState(false);

  const handleToggleRows = () => {
    setShowAll(!showAll);
    setVisibleRows(showAll ? 5 : data.length);
  };

  return (
    <Box>
      <TitleHeaders
        title={"Nos encantaría compartir contigo la calificación de Clupp⭐"}
        subtitle={
          "Clupp ha sido evaluado como el mejor seguro por su excelente cobertura y servicio al cliente. ¡Nos encantaría que siguieras disfrutando de estas ventajas! 😍"
        }
        isRequired={false}
      />
      <TableContainer component={Paper}>
        <Table>
          <TableHead sx={{ padding: "60px" }}>
            <TableRow>
              <TableCell
                sx={{
                  width: "70%",
                  paddingLeft: "10px",
                  textAlign: "center",
                  fontWeight: 600,
                }}
              >
                Seguro
              </TableCell>
              <TableCell
                sx={{ width: "30%", textAlign: "center", fontWeight: 600 }}
              >
                Calificación de desempeño
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.slice(0, visibleRows).map((row, index) => (
              <TableRow key={index}>
                <TableCell sx={{ fontWeight: row.isClupp ? 600 : "" }}>
                  {row.name}
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "right",
                    fontWeight: row.isClupp ? 600 : "",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  {row.isClupp && <StarIcon sx={{ color: "#00BBEE", fontSize: "18px", marginBottom: "2px", marginRight: "3px" }}/>}
                  {row.rating}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box sx={{ textAlign: "center", marginTop: 2 }}>
        <Button variant="contained" onClick={handleToggleRows} disableElevation sx={{textTransform: "none"}}>
          {showAll ? "Mostrar menos" : "Mostrar más"}
        </Button>
      </Box>
    </Box>
  );
};

export default CluppValuation;
